'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COURSE_SUBSCRIPTION_TIERS = exports.COURSE_VISIBILITY = exports.QueryCoursesParamsNotValidError = exports.SubscriptionNotValidError = exports.SubscriptionNotActiveError = exports.SubscriptionNotFoundError = exports.SectionDoesNotExistError = exports.PublishingErrors = exports.CourseEnrollmentDoesNotExistError = exports.CourseEnrollmentBodyNotValidError = exports.DraftObjectConflictError = exports.DraftBodyNotValidError = exports.DraftObjectDoesNotExistError = exports.DraftDoesNotExistError = exports.CourseDoesNotExistError = exports.UnexpectedServerResponse = exports.RequestLimitExceeded = exports.UrlConstructionError = exports.MissingParamError = undefined;

var _clientLibrary = require('@seneca/client-library');

Object.defineProperty(exports, 'MissingParamError', {
  enumerable: true,
  get: function get() {
    return _clientLibrary.MissingParamError;
  }
});
Object.defineProperty(exports, 'UrlConstructionError', {
  enumerable: true,
  get: function get() {
    return _clientLibrary.UrlConstructionError;
  }
});
Object.defineProperty(exports, 'RequestLimitExceeded', {
  enumerable: true,
  get: function get() {
    return _clientLibrary.RequestLimitExceeded;
  }
});
Object.defineProperty(exports, 'UnexpectedServerResponse', {
  enumerable: true,
  get: function get() {
    return _clientLibrary.UnexpectedServerResponse;
  }
});

var _CourseDoesNotExistError = require('./errors/CourseDoesNotExistError');

Object.defineProperty(exports, 'CourseDoesNotExistError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CourseDoesNotExistError).default;
  }
});

var _DraftDoesNotExistError = require('./errors/DraftDoesNotExistError');

Object.defineProperty(exports, 'DraftDoesNotExistError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DraftDoesNotExistError).default;
  }
});

var _DraftObjectDoesNotExistError = require('./errors/DraftObjectDoesNotExistError');

Object.defineProperty(exports, 'DraftObjectDoesNotExistError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DraftObjectDoesNotExistError).default;
  }
});

var _DraftBodyNotValidError = require('./errors/DraftBodyNotValidError');

Object.defineProperty(exports, 'DraftBodyNotValidError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DraftBodyNotValidError).default;
  }
});

var _DraftObjectConflictError = require('./errors/DraftObjectConflictError');

Object.defineProperty(exports, 'DraftObjectConflictError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DraftObjectConflictError).default;
  }
});

var _CourseEnrollmentBodyNotValidError = require('./errors/CourseEnrollmentBodyNotValidError');

Object.defineProperty(exports, 'CourseEnrollmentBodyNotValidError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CourseEnrollmentBodyNotValidError).default;
  }
});

var _CourseEnrollmentDoesNotExistError = require('./errors/CourseEnrollmentDoesNotExistError');

Object.defineProperty(exports, 'CourseEnrollmentDoesNotExistError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CourseEnrollmentDoesNotExistError).default;
  }
});

var _PublishingErrors = require('./errors/PublishingErrors');

Object.defineProperty(exports, 'PublishingErrors', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PublishingErrors).default;
  }
});

var _SectionDoesNotExistError = require('./errors/SectionDoesNotExistError');

Object.defineProperty(exports, 'SectionDoesNotExistError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SectionDoesNotExistError).default;
  }
});

var _SubscriptionNotFoundError = require('./errors/SubscriptionNotFoundError');

Object.defineProperty(exports, 'SubscriptionNotFoundError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SubscriptionNotFoundError).default;
  }
});

var _SubscriptionNotActiveError = require('./errors/SubscriptionNotActiveError');

Object.defineProperty(exports, 'SubscriptionNotActiveError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SubscriptionNotActiveError).default;
  }
});

var _SubscriptionNotValidError = require('./errors/SubscriptionNotValidError');

Object.defineProperty(exports, 'SubscriptionNotValidError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SubscriptionNotValidError).default;
  }
});

var _QueryCoursesParamsNotValidError = require('./errors/QueryCoursesParamsNotValidError');

Object.defineProperty(exports, 'QueryCoursesParamsNotValidError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_QueryCoursesParamsNotValidError).default;
  }
});

var _CourseVisibility = require('./CourseVisibility');

Object.defineProperty(exports, 'COURSE_VISIBILITY', {
  enumerable: true,
  get: function get() {
    return _CourseVisibility.COURSE_VISIBILITY;
  }
});

var _CourseSubscriptionTiers = require('./CourseSubscriptionTiers');

Object.defineProperty(exports, 'COURSE_SUBSCRIPTION_TIERS', {
  enumerable: true,
  get: function get() {
    return _CourseSubscriptionTiers.COURSE_SUBSCRIPTION_TIERS;
  }
});

var _CourseServiceClient = require('./CourseServiceClient');

var _CourseServiceClient2 = _interopRequireDefault(_CourseServiceClient);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = _CourseServiceClient2.default;